module.exports = __webpack_public_path__ + "pf.svg?b5477fd9e505c34b7480fa7aecab3e2e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pf.svg
// module id = 1101
// module chunks = 27